import { useMemo } from "react";
import { useEffect, useState } from "react";
import SeniorenplatformItem from "../SeniorenplatformItem/SeniorenplatformItem"
import { Swiper, SwiperSlide } from 'swiper/react';
// Import Swiper styles
import 'swiper/css';
import { Loading } from "../../FicheLijst/Loading/Loading";

export const SeniorenplatformRelevantExercises = (props) => {

    const [relativeExercises, setRelativeExercises] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        setIsLoading(true);
        if (props.entry.folderId) {
            fetch(`/umbraco/api/seniorenplatform/GetRelevantExercises?poId=${props.poId}&folderId=${props.entry.folderId}&muscleGroup=${props.entry.muscleGroups.map(sg => `${sg}`)}&entryName=${props.entry.name}`)
                .then(response => {
                    var data = response.json();
                    data.then(data => {
                        setRelativeExercises(data);
                        setIsLoading(false);
                    }).catch(error => {
                        console.log(error);
                        setRelativeExercises(null);
                        setIsLoading(false);
                    });
                })
                .catch(() => {
                    console.error("Error while fetching data");
                    setRelativeExercises(null);
                    setIsLoading(false);
                });
        }
    }, [props.folderId, props.entry.id])

    useEffect(() => {
        
        //Filter relevant exercises, remove the one where id is the same as the current exercise props.entry.id
        setIsLoading(false);

        //Check if relativeExercises contains an item with the same id as the current exercise
        if(relativeExercises && relativeExercises.find(exercise => exercise.id === props.entry.id)) {
            setRelativeExercises(relativeExercises.filter(exercise => exercise.id !== props.entry.id));
        }
        else{
            setIsLoading(false);
        }
    }, [JSON.stringify(relativeExercises)])

    const relevantCards = useMemo(() => {
        if (relativeExercises) {
            return relativeExercises.map((exercise, index) => {                
                    return <SeniorenplatformItem
                        item={exercise}
                        key={index}
                        dictionary={props.dictionary}
                        toggleIsFavorites={props.toggleIsFavorites}
                        getDetailsOfItem={props.getDetailsOfItem} />
            }
            );
        }
    }, [JSON.stringify(relativeExercises), JSON.stringify(props.entries)]);

    const relevantSliderItems = useMemo(() => {
        if (relativeExercises) {
            return relativeExercises.map((item, index) => {
                    return <SwiperSlide key={index}>
                        <SeniorenplatformItem
                            item={item}
                            key={index}
                            dictionary={props.dictionary}
                            toggleIsFavorites={props.toggleIsFavorites}
                            getDetailsOfItem={props.getDetailsOfItem} />
                    </SwiperSlide>
             }
            )
        }
    }, [JSON.stringify(relativeExercises)]);

    return relevantCards && relevantCards.length > 0 ? (
        !isLoading ? <div className="c-senioren__detail__exercises">
        <h3>
            {props.dictionary.relevantExercises}
        </h3>
        <div className="c-senioren__detail__exercises__swiper">
            <Swiper
                spaceBetween={50}
                slidesPerView={1.5}
            >
                {relevantSliderItems}
            </Swiper>
        </div>
        <div className="c-senioren__detail__exercises__items">
            {relevantCards}
        </div>
    </div>
    : <Loading/>
    )
        : null

}